/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class JavascriptTransformerModel {
        public mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public currentJavascriptTransformer: Wars.Domain.Model.Gis.JavascriptTransformer;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private mapConfigurationId: string) {
            mapConfigurationService.getMapConfiguration(mapConfigurationId).then(m => {
                this.mapConfiguration = m;
            });
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public addJavascriptTransformer() {
            let newTransformer = this.mapConfigurationService.createJavascriptTransformer();
            newTransformer.name = "New Transformer";
            newTransformer.code = "return value;";
            this.mapConfiguration.javascriptTransformers.push(newTransformer);
            this.currentJavascriptTransformer = newTransformer;
            this.save();
        }

        public delete() {
            this.currentJavascriptTransformer.entityAspect.setDeleted();
            this.save();
        }
    }
}